import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/operations/quotes/$id')({
  component: OperationsQuoteIdLayout,
});

function OperationsQuoteIdLayout() {
  return <Outlet />;
}
